/**
 * Main JavaScript entry file
 * This file imports all JavaScript dependencies and our Sass files
 */

// Import Styles
import '../scss/main.scss';

// Import Bootstrap JS components
import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/offcanvas';
import 'bootstrap/js/dist/popover';
import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/toast';
import 'bootstrap/js/dist/tooltip';

// Import custom components
import './hero-slider';

// Initialize experts section tabs
function initExpertsTabs() {
  const expertsTabs = document.querySelectorAll('.experts-section__tab');
  const expertsGrid = document.querySelector('.experts-section__grid');
  
  if (expertsTabs.length && expertsGrid) {
    // Safari fix - force a layout recalculation on first load for mobile devices
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isMobile = window.innerWidth <= 991;
    
    if (isSafari && isMobile) {
      // Force a reflow for Safari mobile
      setTimeout(() => {
        const activeTab = document.querySelector('.experts-section__tab.active');
        if (activeTab) {
          // Get current active tag
          const currentTag = activeTab.getAttribute('data-tag');
          
          // Hide all elements first
          const allElements = expertsGrid.querySelectorAll('[data-tag]');
          allElements.forEach(el => {
            el.style.display = 'none';
          });
          
          // Then show the active ones with a slight delay to force reflow
          setTimeout(() => {
            const activeElements = expertsGrid.querySelectorAll(`[data-tag="${currentTag}"]`);
            activeElements.forEach(el => {
              el.style.display = '';
            });
          }, 50);
        }
      }, 100);
    }
    
    expertsTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Skip if already active
        if (tab.classList.contains('active')) return;
        
        // Remove active class from all tabs
        expertsTabs.forEach(t => t.classList.remove('active'));
        
        // Add active class to clicked tab
        tab.classList.add('active');
        
        // Get tag from data attribute
        const selectedTag = tab.getAttribute('data-tag');
        
        // Get all elements with data-tag attribute
        const taggedElements = expertsGrid.querySelectorAll('[data-tag]');
        
        // Show/hide elements based on tag
        taggedElements.forEach(element => {
          const elementTag = element.getAttribute('data-tag');
          if (elementTag === selectedTag) {
            element.style.display = ''; // Show elements with matching tag
          } else {
            element.style.display = 'none'; // Hide others
          }
        });
      });
    });
  }
}

// Initialize advice section tabs
function initAdviceTabs() {
  const tabs = document.querySelectorAll('.advice-section__tab');
  const posts = document.querySelectorAll('.advice-post');
  const seeAllLink = document.querySelector('.advice-section__footer a');
  
  if (!tabs.length) return;
  
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const selectedTag = tab.dataset.tag;
      const selectedText = tab.textContent.trim();
      
      // Update active tab
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      
      // Show/hide posts
      posts.forEach(post => {
        if (post.dataset.tag === selectedTag) {
          post.style.display = '';
        } else {
          post.style.display = 'none';
        }
      });
      
      // Update "See all" link text and href
      if (seeAllLink) {
        // Update href to point to the selected tag
        seeAllLink.href = `/tag/${selectedTag}`;
        
        // Update button text
        seeAllLink.textContent = '';
        seeAllLink.textContent = `See all ${selectedText.toLowerCase()}`;
        
        // Re-create the SVG icon
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("width", "16");
        svg.setAttribute("height", "14");
        svg.setAttribute("viewBox", "0 0 16 14");
        svg.setAttribute("fill", "none");
        
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", "M1.125 7H14.875M14.875 7L9.25 1.375M14.875 7L9.25 12.625");
        path.setAttribute("stroke", "#F37635");
        path.setAttribute("stroke-linecap", "round");
        path.setAttribute("stroke-linejoin", "round");
        
        svg.appendChild(path);
        seeAllLink.appendChild(svg);
      }
    });
  });
}

// Initialize popovers and tooltips
document.addEventListener('DOMContentLoaded', () => {
  // Initialize tooltips
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Initialize popovers
  const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl);
  });

  // Add class to body when mobile menu checkbox is checked
  const mobileMenuCheckbox = document.getElementById('mobile-menu-checkbox');
  if (mobileMenuCheckbox) {
    mobileMenuCheckbox.addEventListener('change', () => {
      if (mobileMenuCheckbox.checked) {
        document.body.classList.add('menu-open');
      } else {
        document.body.classList.remove('menu-open');
      }
    });
  }

  // Search form toggle
  const searchButton = document.querySelector('.search-button');
  const searchForm = document.querySelector('.search-form');
  
  if (searchButton && searchForm) {
    searchButton.addEventListener('click', (event) => {
      event.preventDefault();
      searchForm.classList.toggle('active');
      
      if (searchForm.classList.contains('active')) {
        searchForm.querySelector('input').focus();
      }
    });

    // Close search form when clicking outside of it
    document.addEventListener('click', (event) => {
      if (searchForm.classList.contains('active')) {
        if (!searchForm.contains(event.target) && !searchButton.contains(event.target)) {
          searchForm.classList.remove('active');
        }
      }
    });
  }
  
  // Initialize experts section tabs
  initExpertsTabs();
  
  // Initialize advice section tabs
  initAdviceTabs();

  // Title Animation
  const animateHeroTitle = () => {
    const animationContainer = document.querySelector('.hero-section__title-animation');
    if (!animationContainer) return;

    const spans = animationContainer.querySelectorAll('span');
    if (!spans.length) return;
    
    let currentIndex = 0;

    // Hide all spans first but keep them at top position
    spans.forEach(span => {
      span.style.opacity = '0';
      // Don't change top position of inactive spans
      
      // Make sure the color is applied based on data-color
      const colorType = span.getAttribute('data-color');
      if (colorType === 'primary') {
        span.style.color = '#F6854E'; // Matches the previous inline color
      } else if (colorType === 'secondary') {
        span.style.color = '#34558B'; // Matches the previous inline color
      } else if (colorType === 'tertiary') {
        span.style.color = '#015760'; // Matches the previous inline color
      } else if (colorType === 'warning') {
        span.style.color = '#FDB022'; // Matches the previous inline color
      }
    });

    // Add a small delay to ensure fonts are loaded
    setTimeout(() => {
      // Initialize the first span
      spans[currentIndex].classList.add('active');
      spans[currentIndex].style.opacity = '1';
      
      // Set the minimum width based on the widest span but responsive to screen size
      let maxWidth = 0;
      spans.forEach(span => {
        // Force rendering to get accurate width
        span.style.visibility = 'hidden';
        span.style.position = 'static';
        span.style.display = 'inline-block';
        const width = span.offsetWidth;
        span.style.visibility = '';
        span.style.position = '';
        span.style.display = '';
        if (width > maxWidth) maxWidth = width;
      });
      
      // Adjust min-width to be responsive to screen width
      if (maxWidth > 0) {
        if (window.innerWidth <= 576) {
          // On very small screens, let it take available width
          animationContainer.style.minWidth = `auto`;
          animationContainer.style.width = '100%';
        } else if (window.innerWidth <= 768) {
          // On mobile devices, set a more appropriate width
          animationContainer.style.minWidth = `${Math.min(maxWidth, 180)}px`;
        } else {
          // On larger screens, use the calculated max width plus padding
          animationContainer.style.minWidth = `${maxWidth + 45}px`;
        }
      }
      
      // Update min-width on window resize
      window.addEventListener('resize', () => {
        if (window.innerWidth <= 576) {
          animationContainer.style.minWidth = `auto`;
          animationContainer.style.width = '100%';
        } else if (window.innerWidth <= 768) {
          animationContainer.style.minWidth = `${Math.min(maxWidth, 180)}px`;
        } else {
          animationContainer.style.minWidth = `${maxWidth + 20}px`;
        }
      });
    }, 100);

    // Set up the animation interval
    const animationInterval = setInterval(() => {
      // For exit animation
      spans[currentIndex].classList.remove('active');
      spans[currentIndex].classList.add('exit');
      spans[currentIndex].style.top = '-100%';
      spans[currentIndex].style.opacity = '0';

      // Calculate next index
      currentIndex = (currentIndex + 1) % spans.length;

      // Add active class to next span (already at top: 0)
      spans[currentIndex].classList.add('active');
      spans[currentIndex].style.top = '0'; 
      spans[currentIndex].style.opacity = '1';

      // After animation completes, reset exited span
      setTimeout(() => {
        const exitSpan = document.querySelector('.hero-section__title-animation .exit');
        if (exitSpan) {
          exitSpan.classList.remove('exit');
          exitSpan.style.top = '0'; // Keep at top position but invisible
          exitSpan.style.opacity = '0';
        }
      }, 500);
    }, 3000); // Change every 3 seconds
  };

  animateHeroTitle();

  // Handle newsletter subscription
  function handleNewsletterSubmit(formElement, messageElement) {
    return async function(e) {
      e.preventDefault();
      const email = e.target.email.value;
      console.log('Newsletter form submitted with email:', email);
      
      // Show loading message
      messageElement.textContent = 'Sending...';
      messageElement.style.display = 'block';
      messageElement.className = messageElement.className.replace(/ (success|error)/g, '');

      try {
        console.log('Sending request to /wp-json/custom/v1/subscribe');
        const response = await fetch('/wp-json/custom/v1/subscribe', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ email })
        });

        console.log('Response status:', response.status);
        const data = await response.json();
        console.log('Response data:', data);
        
        if (response.ok) {
          // Show success message
          messageElement.textContent = 'Thanks for subscribing!';
          messageElement.className = messageElement.className + ' success';
          
          // Clear the form
          e.target.reset();
        } else {
          // Show error message
          messageElement.textContent = 'Subscription failed. ' + (data.message || 'Please try again.');
          messageElement.className = messageElement.className + ' error';
        }
      } catch (error) {
        console.error('Error during subscription:', error);
        
        // Show error message
        messageElement.textContent = 'An error occurred. Please try again.';
        messageElement.className = messageElement.className + ' error';
      }
    };
  }

  // Initialize footer newsletter form
  const footerForm = document.getElementById('newsletter-form');
  if (footerForm) {
    const footerMessage = document.getElementById('newsletter-message');
    footerForm.addEventListener('submit', handleNewsletterSubmit(footerForm, footerMessage));
  }
  
  // Initialize post newsletter form
  const postForm = document.getElementById('post-newsletter-form');
  if (postForm) {
    const postMessage = document.getElementById('post-newsletter-message');
    postForm.addEventListener('submit', handleNewsletterSubmit(postForm, postMessage));
  }
}); 